import sha256 from "crypto-js/sha256";
import { Buffer } from "buffer";
import { urlEncodeB64 } from "./urlEncodeB64";

export async function generateChallenge(verifier: string): Promise<string> {
    const hash = await sha256(verifier).toString();

    return urlEncodeB64(Buffer.from(hash, "hex").toString("base64"));
}
